import teamsRaw from './teams.json';
import { playerNames } from './playerNames.js';

const TOTAL_JOGADORES = 20;

const NOMES_PT = {
  MEX: 'México', RSA: 'África do Sul', KOR: 'Coreia do Sul', CZE: 'Rep. Tcheca',
  CAN: 'Canadá', BIH: 'Bósnia-Herz.', QAT: 'Catar', SUI: 'Suíça',
  BRA: 'Brasil', MAR: 'Marrocos', HAI: 'Haiti', SCO: 'Escócia',
  USA: 'Estados Unidos', PAR: 'Paraguai', AUS: 'Austrália', TUR: 'Turquia',
  GER: 'Alemanha', CUW: 'Curaçao', CIV: 'Costa do Marfim', ECU: 'Equador',
  NED: 'Holanda', JPN: 'Japão', SWE: 'Suécia', TUN: 'Tunísia',
  BEL: 'Bélgica', EGY: 'Egito', IRN: 'Irã', NZL: 'Nova Zelândia',
  ESP: 'Espanha', CPV: 'Cabo Verde', KSA: 'Arábia Saudita', URU: 'Uruguai',
  FRA: 'França', SEN: 'Senegal', IRQ: 'Iraque', NOR: 'Noruega',
  ARG: 'Argentina', ALG: 'Argélia', AUT: 'Áustria', JOR: 'Jordânia',
  POR: 'Portugal', COD: 'Rep. Dem. Congo', UZB: 'Uzbequistão', COL: 'Colômbia',
  ENG: 'Inglaterra', CRO: 'Croácia', GHA: 'Gana', PAN: 'Panamá',
};

function gerarJogadores(sigla, total, inicio = 1) {
  const jogadores = {};
  const timesNames = playerNames[sigla] || {};

  for (let i = inicio; i < inicio + total; i++) {
    const key = `${sigla}_${String(i).padStart(2, '0')}`;
    const playerName = timesNames[key] || `${sigla} ${i}`;
    jogadores[key] = { nome: playerName, obtida: false };
  }
  return jogadores;
}

// Grupos dos times (A–L)
const gruposTimes = {};
for (const team of teamsRaw) {
  const sigla = team.fifa_code;
  const grupo = team.group;
  if (!gruposTimes[grupo]) gruposTimes[grupo] = [];
  gruposTimes[grupo].push({
    sigla,
    nome: NOMES_PT[sigla] || team.name,
    flag: team.flag_icon,
    grupo,
    theme: 'default',
    totalFigurinhas: TOTAL_JOGADORES,
    jogadores: gerarJogadores(sigla, TOTAL_JOGADORES),
  });
}

// Grupos especiais
export const GRUPO_FWC = {
  sigla: 'FWC',
  nome: 'FIFA World Cup 2026',
  flag: '🏆',
  grupo: 'FWC',
  theme: 'fifa',
  totalFigurinhas: 20,
  // FWC 0 até FWC 19
  jogadores: (() => {
    const j = {};
    for (let i = 0; i <= 19; i++) {
      const key = `FWC_${String(i).padStart(2, '0')}`;
      j[key] = { nome: `FWC ${i}`, obtida: false };
    }
    return j;
  })(),
};

export const GRUPO_CC = {
  sigla: 'CC',
  nome: 'Coca-Cola',
  flag: '🥤',
  grupo: 'CC',
  theme: 'coca',
  totalFigurinhas: 14,
  // CC 1 até CC 14
  jogadores: gerarJogadores('CC', 14, 1),
};

export const GRUPO_REGU = {
  sigla: 'REGU',
  nome: 'Regular',
  flag: '⭐',
  grupo: 'REGU',
  theme: 'extras',
  totalFigurinhas: 1,
  jogadores: { REGU_01: { nome: 'REGU-1 Regular', obtida: false } },
};

export const GRUPO_BRO = {
  sigla: 'BRO',
  nome: 'Bronze',
  flag: '🥉',
  grupo: 'BRO',
  theme: 'extras',
  totalFigurinhas: 1,
  jogadores: { BRO_01: { nome: 'BRO-1 Bronze', obtida: false } },
};

export const GRUPO_PRA = {
  sigla: 'PRA',
  nome: 'Prata',
  flag: '🥈',
  grupo: 'PRA',
  theme: 'extras',
  totalFigurinhas: 1,
  jogadores: { PRA_01: { nome: 'PRA-1 Prata', obtida: false } },
};

export const GRUPO_OURO = {
  sigla: 'OURO',
  nome: 'Ouro',
  flag: '🥇',
  grupo: 'OURO',
  theme: 'extras',
  totalFigurinhas: 1,
  jogadores: { OURO_01: { nome: 'OURO-1 Ouro', obtida: false } },
};

export const GRUPO_EXTRAS = {
  sigla: 'EXTRAS',
  nome: 'Extras',
  flag: '⭐',
  grupo: 'EXTRAS',
  theme: 'extras',
  totalFigurinhas: 4,
  jogadores: {},
};

export const GRUPOS_ORDENADOS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];

// Ordem original dos times por grupo, conforme o álbum físico
export const ORDEM_TIMES_POR_GRUPO = {};
for (const team of teamsRaw) {
  const g = team.group;
  if (!ORDEM_TIMES_POR_GRUPO[g]) ORDEM_TIMES_POR_GRUPO[g] = [];
  ORDEM_TIMES_POR_GRUPO[g].push(team.fifa_code);
}
export const GRUPOS_ESPECIAIS = ['FWC', 'CC', 'EXTRAS'];

export const copa2026 = gruposTimes;

export function criarStickersVazios() {
  const stickers = {};

  for (const grupo of GRUPOS_ORDENADOS) {
    for (const pais of gruposTimes[grupo]) {
      stickers[pais.sigla] = {
        sigla: pais.sigla,
        nome: pais.nome,
        flag: pais.flag,
        grupo: pais.grupo,
        theme: 'default',
        totalFigurinhas: TOTAL_JOGADORES,
        jogadores: gerarJogadores(pais.sigla, TOTAL_JOGADORES),
      };
    }
  }

  stickers['FWC'] = { ...GRUPO_FWC, jogadores: { ...GRUPO_FWC.jogadores } };
  stickers['CC'] = { ...GRUPO_CC, jogadores: { ...GRUPO_CC.jogadores } };

  stickers['EXTRAS'] = {
    ...GRUPO_EXTRAS,
    jogadores: {
      ...GRUPO_REGU.jogadores,
      ...GRUPO_BRO.jogadores,
      ...GRUPO_PRA.jogadores,
      ...GRUPO_OURO.jogadores,
    },
  };

  return stickers;
}
